var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-edition-section-navigation-menu"},[_c('AtomEditionSectionNavigationMenu',{attrs:{"itemsAsideMenu":_vm.itemsAsideMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }